import {Component, Input, OnChanges, ViewChild} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {AuthService} from "../../_services/auth.service";
import {Router} from "@angular/router";
import {MatSnackBar} from "@angular/material/snack-bar";
import {MatStepper} from "@angular/material/stepper";
import {Community, QuestionAnswer} from '../../_types/communities';
import {OnboardingQuestionsComponent} from '../onboarding-questions/onboarding-questions.component';
import {take} from "rxjs";
import {ContentService} from "../../_services/content.service";
import {ThemeService} from "../../_services/theme.service";

@Component({
    selector: 'app-register',
    templateUrl: './register.component.html',
    styleUrl: './register.component.scss'
})
export class RegisterComponent implements OnChanges {
    @Input() invite: any;
    @Input() community?: Community;
    signUpForm: FormGroup;
    loading: boolean = true;
    companyImg: string = localStorage.getItem('communityLogo') || 'assets/explainLogoPlaceholder.png';
    companyName: string = localStorage.getItem('communityName') || 'Explain'
    image: any;
    photoFile: any;
    maxFileSize: number = 10;
    showCropper: boolean = false;
    login: boolean = false;
    imageChangedEvent: any = '';
    eligibilityAnswers: QuestionAnswer[] = []
    profileAnswers: QuestionAnswer[] = []
    loginForm: FormGroup;
    passwordType: string = 'password';
    @ViewChild('stepper') private myStepper: MatStepper | undefined;
    @ViewChild('appOnboardingQuestionsComponent', {static: false}) private appOnboardingQuestionsComponent?: OnboardingQuestionsComponent;

    constructor(private readonly formBuilder: FormBuilder,
                private authService: AuthService,
                public readonly themeService: ThemeService,
                private readonly router: Router,
                private readonly snackBar: MatSnackBar,
                private readonly contentService: ContentService) {
        this.signUpForm = this.formBuilder.group({
            username: ['', [Validators.required, Validators.pattern('^[a-zA-Z0-9._-]+$')]],
            postcode: ['', [Validators.required, Validators.pattern('^\\w{2,4}$'), Validators.minLength(2)]],
            email: ['', [Validators.required, Validators.email]],
            confirmEmail: ['', [Validators.required, Validators.email]],
            password: ['', [Validators.required, Validators.minLength(8), Validators.maxLength(32)]],
            confirmPassword: ['', Validators.required, Validators.minLength(8), Validators.maxLength(32)],
            termsConsent: [false],
            privacyConsent: [false],
            bio: [''],
        });
        this.loginForm = this.formBuilder.group({
            email: ['', [Validators.required, Validators.email]],
            password: ['', Validators.required],
        });
    }


    ngOnChanges(): void {
        if (this.community?.hide_post_code) {
            this.signUpForm.get('postcode')?.setErrors(null);
            this.signUpForm.get('postcode')?.clearValidators();
            this.signUpForm.get('postcode')?.updateValueAndValidity();
        } else {
            this.signUpForm.get('postcode')?.clearValidators();
            this.signUpForm.get('postcode')?.addValidators([Validators.required, Validators.pattern('^\\w{2,4}$'), Validators.minLength(2)]);
            this.signUpForm.get('postcode')?.updateValueAndValidity();
        }

        if (this.community) {
            this.companyImg = this.community.logo;
            this.companyName = this.community.name;
            this.loading = false;

        } else {
            this.loading = false;
        }
        if (this.invite) {
            this.signUpForm.patchValue({
                email: this.invite.email,
                confirmEmail: this.invite.email
            })
        }
    }


    imageCropped(event: any): void {
        this.photoFile = new File([event.blob], "profile_picture.png");
        const reader: FileReader = new FileReader();
        reader.readAsDataURL(event.blob);
        const that: this = this;
        reader.onloadend = function (): void {
            const base64data: string | ArrayBuffer | null = reader.result;
            if (base64data) {
                that.image = base64data;
            }
        };
    }

    create(): void {
        this.loading = true;
        let body: any = {
            "password": this.signUpForm.value.password,
            "username": this.signUpForm.value.username,
            "email": this.signUpForm.value.email,
            "bio": this.signUpForm.value.bio,
            "postcode": this.signUpForm.value.postcode,
        }

        if (!this.invite?.invite_token) {
            if (this.community?.id) {
                body.community_id = this.community?.id;
            } else {
                this.openSnackBar('There has been an error setting your community please try again', 'error')
                return;
            }
        }
        this.authService.createUser(body, this.photoFile, this.invite?.invite_token)
            .subscribe(
                (data: any): void => {
                    this.loading = false;
                    this.authService.login(this.signUpForm.value.email, this.signUpForm.value.password)
                        .subscribe(
                            (data: any): void => {
                                this.authService.setUser(data.data);
                                this.completeRegistration(data.data.id)
                            },
                            (error: any): void => {
                                if (error.message && error.message.en) {
                                    this.openSnackBar(error.message.en, 'error')
                                } else {
                                    this.openSnackBar(error, 'error')
                                }
                                this.loading = false;
                            });
                },
                (error: any): void => {
                    if (error['username'] === 'A user with that username already exists') {
                        this.openSnackBar('Your username matches an existing explain account please login to complete your registration to this community', 'error')
                        this.login = true;
                    } else if (error === 'A user with that email address already exists') {
                        this.openSnackBar('Your email matches an existing explain account please login to complete your registration to this community', 'error')
                        this.login = true;
                    } else if (error.message && error.message.en) {
                        this.openSnackBar(error.message.en, 'error')
                    } else {
                        this.openSnackBar(error, 'error')
                    }
                    this.loading = false;
                });
    }


    existingUserLogin(): void {
        this.loading = true;
        this.authService.login(this.loginForm.value.email, this.loginForm.value.password)
            .subscribe(
                (data: any): void => {
                    const user = data.data;
                    this.authService.addUserToCommunity(this.community!.id, user.token).subscribe(r => {
                        this.authService.setUser(user);
                        this.completeRegistration(user.id)
                    }, error => {
                        if (error.message && error.message.en) {
                            this.openSnackBar(error.message.en, 'error')
                        } else {
                            this.openSnackBar(error, 'error')
                        }
                        this.loading = false;
                    })
                },
                (error: any): void => {
                    if (error.message && error.message.en) {
                        this.openSnackBar(error.message.en, 'error')
                    } else {
                        this.openSnackBar(error, 'error')
                    }
                    this.loading = false;
                });
    }

    completeRegistration(userId: number): void {
        const that = this;
        if (this.eligibilityAnswers.length > 0) {
            this.sendEligibility().then(function (): void {

                if (that.profileAnswers.length > 0) {
                    that.sendProfileQuestions(userId).then(function (): void {
                        that.postRegistrationRedirect()
                    })
                } else {
                    that.postRegistrationRedirect()
                }
            })
        } else if (that.profileAnswers.length > 0) {
            that.sendProfileQuestions(userId).then(function (): void {
                that.postRegistrationRedirect()
            })
        } else {
            that.postRegistrationRedirect()
        }
    }

    sendEligibility() {
        return new Promise((resolve, reject): void => {
            this.authService.checkEligibility(this.community!.id, this.eligibilityAnswers).pipe(take(1)).subscribe(r => {
                if (this.community) {
                    this.contentService.setCurrentDashboardCommunity(this.community)
                }
                resolve(r)
            }, e => {
                reject(e)
                this.openSnackBar(e, 'error')
            })
        });
    }

    postRegistrationRedirect() {
        this.openSnackBar('Community Registration Complete', 'success')
        if (this.community && this.community.register_post_redirect) {
            this.router.navigate(['/feed', this.community.register_post_redirect]);
        } else {
            this.router.navigate(['/feed']);
        }
    }

    sendProfileQuestions(userId: number) {
        return new Promise((resolve, reject): void => {
            let done: number = 0;
            for (let answer of this.profileAnswers) {
                (answer as any)['user'] = userId;
                if (answer.options && answer.options[0] == null) {
                    answer.options = [];
                }
                this.authService.postProfileQuestionAnswer(answer).pipe(take(1)).subscribe(r => {
                    done++
                    if (done == this.profileAnswers.length) {
                        resolve(r)
                    }
                }, e => {
                    reject(e)
                    this.openSnackBar(e, 'error')
                })
            }
        });
    }

    onFileInput(event: any): void {
        (event.target as HTMLInputElement).value = '';
        if (!event.target.files[0]) {
            this.openSnackBar("Error Selecting Image.", 'error');
            return;
        }
        this.photoFile = event.target.files[0]

        var mimeType = this.photoFile?.type;
        if (mimeType?.match(/image\/*/) == null || !mimeType) {
            // check if image
            this.openSnackBar("Only images are supported.", 'error')
            return;
        }

        let filesize: number = parseFloat(((this.photoFile.size / 1024) / 1024).toFixed(1));

        if (filesize > this.maxFileSize) {
            this.openSnackBar('File too large (' + filesize + 'MB) max file size is ' + this.maxFileSize + 'MB', 'error')
            return;
        }
        this.showCropper = true;
        this.imageChangedEvent = event;

        var reader: FileReader = new FileReader();
        reader.readAsDataURL(this.photoFile);
        reader.onload = (_event): void => {
            if (reader.result) {
                this.image = reader.result;
            } else {
                this.openSnackBar("Reader result returned null.", 'error')
            }
        }
    }

    checkEligibility(): void {
        this.myStepper?.next();
    }

    openSnackBar(message: string, type: string): void {
        this.snackBar.open(message, 'Dismiss', {
            duration: 5000,
            panelClass: [type]
        });
    }

    setAnswers(answers: QuestionAnswer[]): void {
        this.eligibilityAnswers = answers;
    }

    setProfileAnswers(answers: QuestionAnswer[]): void {
        this.myStepper?.next();
        this.profileAnswers = answers;
    }

    showPassword(): void {
        if (this.passwordType == 'password') {
            this.passwordType = 'text';
        } else {
            this.passwordType = 'password';
        }
    }
}
